// @flow
import addressFormFragment from 'Components/widgets/address-form/AddressForm.fragment';
const profileFragment = `
  fragment BookingProfile on Profile {
    optinEmail
    optinSms
    optinPhone
    optinMail
    optinClubmedPlus
    address {
      ...Address
    }
    passport{
      issuingDate
      expirationDate
      nationality
      documentNumber
    }
   dateOfBirth
   civility
   mobilePhoneNumber
  }
  ${addressFormFragment}
`;

/**
 * Common fields between adults and children
 * customerId is used as temp id, till being override by real proposal attendees id
 * see addSearchDataToAttendees
 *  */
const commonProfileFieldsFragment = `
  fragment CommonProfileFields on Profile {
    birthdate:dateOfBirth
    civility
    firstName
    gmNumber
    id:customerId 
    lastName
    neolid:customerId
    unicodeFirstName
    unicodeLastName
  }
`;
export { profileFragment, commonProfileFieldsFragment };
